import { AcademyModel } from '@modules/academy/academy-model';

const { fields } = AcademyModel;

export default [
  fields.id,
  fields.name,
  fields.propertyOwner,
  fields.createdAt
];
